import { DirectMessagePage } from './directMessage.page';

export default DirectMessagePage;
